import React from "react";
import {Button, Drawer, Form, Input, Select, Spin} from "antd";

const Option = Select.Option;
const FormItem = Form.Item;
const {TextArea} = Input;

export class TaskStatus extends React.Component {
  state = {
    visible: false,
    value: [],
    fetching: false
  };

  componentDidMount() {
    if (this.props.onRef)
      this.props.onRef(this)
  }

  componentWillUnmount() {
    if (this.props.onRef)
      this.props.onRef(null)
  }
  handleChange = value => {
    this.setState({
      value,
      fetching: false
    });
  };

  render() {
    const {fetching, data, value} = this.state;
    return (
      <div className="pos-relative">
        <Select mode="default" labelInValue showSearch value={value} placeholder="Select Status"
                notFoundContent={fetching ? <Spin size="small"/> : null} filterOption={false}
                style={{width: "100%"}} onChange={this.handleChange} >
            <Option key="1">Complete</Option>
            <Option key="2">Pending</Option>
            <Option key="3">Process</Option>
            <Option key="4">Dead</Option>
        </Select>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/crm/project_log/log_components/TaskStatus.jsx